import * as React from 'react';
var Sentinel = function (_a) {
    var onLoad = _a.onLoad;
    var ref = React.useRef(null);
    React.useLayoutEffect(function () {
        if (ref.current === null) {
            return undefined;
        }
        var observer = new IntersectionObserver(function (entries) {
            if (entries.find(function (entry) { return entry.isIntersecting; }) !== undefined) {
                onLoad();
            }
        }, {});
        observer.observe(ref.current);
        return function () {
            observer.disconnect();
        };
    }, []);
    return (<span ref={ref} style={{ position: 'absolute', left: 0, bottom: 0, width: 0, height: '40%', maxHeight: 2000 }}/>);
};
export var InfiniteScroll = function (_a) {
    var children = _a.children, onLoad = _a.onLoad, marginTop = _a.marginTop;
    return (<div style={{ position: 'relative', marginTop: marginTop }}>
		{children}
		<Sentinel onLoad={onLoad}/>
	</div>);
};
